import React, { useCallback, useReducer, useMemo, useEffect } from "react";
import PickUp from "../../drag-drop-template/pick-up";
import DropZone from "../../drag-drop-template/drop-zone";
import './style.scss';

type Props = {
    onComplete?: () => void
}

type Item = {
    value: string
}

type Basket = {
    id: string,
    answer?: string,
    items: string[],
    description: string
}

type GameState = {
    baskets: Basket[],
    items: Item[]
}

const TaskGame10: React.FunctionComponent<Props> = ({ onComplete }) => {

    const [gameData, moveEgg] = useReducer((state: GameState, { itemId, basket }: { itemId: string, basket: string }) => {
        return {
            ...state,
            baskets: state.baskets.map(b => {

                const items = b.items.filter(i => i !== itemId);

                if (b.id === basket) {
                    if (state.items.find(i => i.value === itemId)) {
                        items[0] = itemId;
                    }
                }

                return {
                    ...b,
                    items
                }
            })
        }
    }, {
        baskets: [
            {
                id: 'b1',
                answer: 'uprzedzenie',
                items: [],
                description: `Negatywne nastawienie do danej grupy i jej członkiń/członków (np.: pogarda, nienawiść, obrzydzenie). Uprzedzenie jest trwałe, trudne do zmiany, wiąże się też z silnymi emocjami, takimi jak lęk czy złość. Często oparte jest na stereotypie.`
            },
            {
                id: 'b2',
                answer: 'wykluczenie',
                items: [],
                description: `O wykluczeniu mówimy, kiedy dana osoba nie może – nie z własnej woli – uczestniczyć w życiu danej grupy. Wykluczenie może też dotyczyć całej grupy mniejszościowej w społeczeństwie. Ma bardzo różne formy: separacja (fizyczne oddzielenie), marginalizacja (trwałe ignorowanie potrzeb i dążeń danej grupy), segregacja (dzielenie grup na kategorie osób „lepszych” i „gorszych”, którym przysługuje mniej praw). Wykluczenie może dotyczyć różnych dziedzin życia – edukacji, gospodarki, kultury, polityki. Wzmacnia stereotypy i podział międzygrupowy.`
            },
            {
                id: 'b3',
                answer: 'mechanizm kozła ofiarnego',
                items: [],
                description: `Obwinienie wybranej jednostki lub grupy za złożone, negatywne procesy społeczne. Ten mechanizm uruchamia się często w czasie silnych kryzysów (np.: ekonomicznych, politycznych). Wzmacniają go stereotypy i uprzedzenia, dlatego kozłem ofiarnym zostaje często grupa mniejszościowa, postrzegana jako obca, której przypisywane są negatywne cechy. Mechanizm ten usztywnia podziały między- grupowe. Może istnieć także na poziomie małych grup (klasa, grupa znajomych).`
            },
            {
                id: 'b4',
                answer: 'mowa nienawiści',
                items: [],
                description: `Wypowiedzi i obrazy, które rozpowszechniają i usprawiedliwiają pogardę, wrogość i nienawiść wobec osoby lub grupy ze względu na cechę ich tożsamości. Mowa nienawiści odwołuje się do stereotypów, dehumanizuje i tym samym prowadzi do dyskryminacji i przemocy. Mową nienawiści są też takie wypowiedzi, które wprost nawołują do przemocy.`
            },
            {
                id: 'b5',
                answer: 'efekt widza',
                items: [],
                description: `Mechanizm rozproszenia odpowiedzialności, który polega na tym, że im większa liczba świadków sytuacji, tym mniejsza szansa, że pojedyncza osoba zareaguje. Tę bierność psychologia tłumaczy tym, że kiedy coś złego dzieje się w obecności zbyt wielu świadków, każdy z nich czuje się zwolniony z odpowiedzialności za podjęcie działania.`
            },
            {
                id: 'b6',
                answer: 'dehumanizacja',
                items: [],
                description: `Inaczej odczłowieczenie. Polega na zanegowaniu człowieczeństwa danej osoby lub grupy. Dehumanizacja sprawia, że zaczynamy postrzegać drugiego człowieka jak istotę niższą, nie w pełni ludzką – podobną do zwierzęcia lub przedmiotu, pozbawioną godności, uczuć i emocji, zdolności umysłowych. Dehumanizacja jest szczególnie niebezpieczna, ponieważ wobec kogoś, kto postrzegany jest jako gorszy, łatwiej jest uzasadnić stosowanie przemocy lub nierównego traktowania.`
            }
        ],
        items: [
            {
                value: 'uprzedzenie'
            },
            {
                value: 'wykluczenie'
            },
            {
                value: 'mechanizm kozła ofiarnego'
            },
            {
                value: 'mowa nienawiści'
            },
            {
                value: 'efekt widza'
            },
            {
                value: 'dehumanizacja'
            }
        ]
    })

    const completed = useMemo(() => {
        return gameData.baskets.reduce((prev, b) => {
            return prev && (b.answer === b.items[0]);
        }, true);
    }, [gameData.baskets]);

    useEffect(() => {
        if (completed) {
            if (onComplete) onComplete();
        }
    }, [completed, onComplete])

    const onDrop = useCallback((pickupData: string, dropId: string) => {
        moveEgg({ itemId: pickupData, basket: dropId });
    }, [])


    return (
        <div className="task-game-10">
            <div className="drops">
                <GameDropZone id="b1" game={gameData} onDrop={onDrop}></GameDropZone>
                <GameDropZone id="b2" game={gameData} onDrop={onDrop}></GameDropZone>
                <div className="picks">
                    <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'dehumanizacja')}></GameElement>
                    <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'wykluczenie')}></GameElement>
                    <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'uprzedzenie')}></GameElement>                                        
                    <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'efekt widza')}></GameElement>
                    <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'mowa nienawiści')}></GameElement>
                    <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'mechanizm kozła ofiarnego')}></GameElement>                    
                </div>                
                <GameDropZone id="b3" game={gameData} onDrop={onDrop}></GameDropZone>
                <GameDropZone id="b4" game={gameData} onDrop={onDrop}></GameDropZone>
                <div className="picks">
                    <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'dehumanizacja')}></GameElement>
                    <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'wykluczenie')}></GameElement>
                    <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'uprzedzenie')}></GameElement>                                        
                    <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'efekt widza')}></GameElement>
                    <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'mowa nienawiści')}></GameElement>
                    <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'mechanizm kozła ofiarnego')}></GameElement>
                </div>
                <GameDropZone id="b5" game={gameData} onDrop={onDrop}></GameDropZone>
                <GameDropZone id="b6" game={gameData} onDrop={onDrop}></GameDropZone>
                <div className="picks">
                    <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'dehumanizacja')}></GameElement>
                    <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'wykluczenie')}></GameElement>
                    <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'uprzedzenie')}></GameElement>                                        
                    <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'efekt widza')}></GameElement>
                    <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'mowa nienawiści')}></GameElement>
                    <GameElement isPickable={true} item={gameData.items.find(i => i.value === 'mechanizm kozła ofiarnego')}></GameElement>
                </div>
            </div>

        </div>
    )
}

const GameElement: React.FunctionComponent<{ item?: Item, isPickable: boolean }> = ({ item, isPickable }) => {

    return (
        <>
            {item && <div className="game-element">
                {isPickable && <PickUp
                    data={item.value}
                >
                    <span>{item.value}</span>
                </PickUp>}
                {!isPickable && <span>{item.value}</span>}
            </div>

            }
        </>
    )
}

const GameDropZone: React.FunctionComponent<{
    id: string,
    game: GameState,
    onDrop: (pickupData: string, dropId: string) => void;
}> = ({ id, onDrop, game, children }) => {

    const basket = game.baskets.find(b => b.id === id);
    const itemValue = basket?.items[0] || null;
    const item = game.items.find(i => i.value === itemValue) || null;

    const state = useMemo(() => {
        if (!item) {
            return 'empty'
        }

        return basket?.answer === item?.value ? 'correct' : 'wrong';
    }, [basket, item])

    return (
        <div className={`game-drop-zone ${state}`}>
            <div className="inner">
                <p>{basket?.description}</p>
                <DropZone onDrop={onDrop} id={id}>
                    {
                        item && <GameElement item={item} isPickable={true} ></GameElement>
                    }
                    {
                        !item && <GameElement item={{value: 'upuść tutaj'}} isPickable={false}>upuść tutaj</GameElement>
                    }
                </DropZone>
            </div>
        </div>
    )
}

export default TaskGame10;